export interface HintPanelProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const HintPanel = ({ header, children, className }: HintPanelProps) => (
  <div
    className={`border-color-grey relative rounded-sm border border-solid text-center ${className}`}
  >
    {header && (
      <div className="bg-color-background-base absolute left-1/2 -translate-x-1/2 -translate-y-1/2 transform px-2">
        {header}
      </div>
    )}
    <div className="p-2">{children}</div>
  </div>
);
